import React, { useState, ChangeEvent, FormEvent } from 'react';
import apiHelper from '../../api/ApiHelper';
import './AddArticle.css'; // Import the CSS file
import { Article, Category } from '../types/ArticleTypes';

const AddArticle: React.FC = () => {
    const [title, setTitle] = useState<string>('');
    const [description, setDescription] = useState<string>('');
    const [content, setContent] = useState<string>('');
    const [isDeleted, setIsDeleted] = useState<boolean>(false);
    const [isEnabled, setIsEnabled] = useState<boolean>(true);
    const [category, setCategory] = useState<Category>(Category.Others);
    const [tags, setTags] = useState<string>('');

    const handleSubmit = async (e: FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        try {
            const createdAt = formatDate(new Date());
            await apiHelper.createArticle({ articleId: "", title, description, content, isDeleted, isEnabled, mainImageUrl: "", category, tags: tags.split(',').map(tag => tag.trim()), createdAt } as Article);
            alert('Post saved successfully!');
            setTitle('');
            setDescription('');
            setContent('');
            setIsDeleted(false);
            setIsEnabled(true);
            setCategory(Category.Others);
            setTags('');
        } catch (error) {
            alert('Failed to save post.');
        }
    };

    const formatDate= (date: Date) =>{
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        const year = date.getFullYear();
        return `${month}/${day}/${year}`;
    }
      

    return (
        <div className="add-article-container">
            <h1>Add Article</h1>
            <form onSubmit={handleSubmit} className="add-article-form">
                <div className="form-group">
                    <label>Title:</label>
                    <input
                        type="text"
                        value={title}
                        onChange={(e: ChangeEvent<HTMLInputElement>) => setTitle(e.target.value)}
                    />
                </div>
                <div className="form-group">
                    <label>Description:</label>
                    <textarea
                        style={{ height: '50px' }}
                        value={description}
                        onChange={(e: ChangeEvent<HTMLTextAreaElement>) => setDescription(e.target.value)}
                    />
                </div>
                <div className="form-group">
                    <label>Content:</label>
                    <textarea
                        style={{ height: '200px' }}
                        value={content}
                        onChange={(e: ChangeEvent<HTMLTextAreaElement>) => setContent(e.target.value)}
                    />
                </div>
                <div className="form-group">
                    <label>Category:</label>
                    <select
                        value={category}
                        onChange={(e: ChangeEvent<HTMLSelectElement>) => setCategory(e.target.value as Category)}
                    >
                        <option value="">Select a category</option>
                        {Object.values(Category).map(cat => (
                            <option key={cat} value={cat}>{cat}</option>
                        ))}
                    </select>
                </div>
                <div className="form-group">
                    <label>Tags (comma separated):</label>
                    <input
                        type="text"
                        value={tags}
                        onChange={(e: ChangeEvent<HTMLInputElement>) => setTags(e.target.value)}
                    />
                </div>
                <div className="form-group">
                    <label>
                        <input
                            type="checkbox"
                            checked={isDeleted}
                            onChange={(e: ChangeEvent<HTMLInputElement>) => setIsDeleted(e.target.checked)}
                        />
                        Is Deleted
                    </label>
                </div>
                <div className="form-group">
                    <label>
                        <input
                            type="checkbox"
                            checked={isEnabled}
                            onChange={(e: ChangeEvent<HTMLInputElement>) => setIsEnabled(e.target.checked)}
                        />
                        Is Enabled
                    </label>
                </div>
                <button type="submit">Save Post</button>
            </form>
        </div>
    );
};

export default AddArticle;